import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { ListWarehousesResponse, WarehouseDTO } from '@erp/rpc';

export type { WarehouseDTO };

export function useWarehouses(enabled = true, includeSections = false) {
  return useQuery<ListWarehousesResponse>({
    ...orpc.inventoryManagement.warehouses.list.queryOptions({
      input: { includeSections },
    }),
    enabled,
  });
}

export default useWarehouses;
